import React, { useState, useEffect } from 'react'
import {
  Modal,
  List,
  Checkbox,
  Button,
  Alert,
  Typography,
  message,
  Card,
  Divider
} from 'antd'
import { useTranslation } from 'react-i18next'
import { removeMedias } from '../../../../../services/api/library'

const { Text } = Typography

const BulkDeleteModal = ({ visible, items = [], onSuccess, onCancel }) => {
  const { t } = useTranslation()
  const [checkedIds, setCheckedIds] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      setCheckedIds(items.map(item => item.id))
    }
  }, [visible, items])

  const handleCheck = (id, checked) => {
    setCheckedIds(prev =>
      checked ? [...prev, id] : prev.filter(i => i !== id)
    )
  }

  const handleDelete = async () => {
    setLoading(true)
    try {
      await removeMedias({ mediaIds: checkedIds })
      message.success(t('media:delete_success'))
      setLoading(false)
      onSuccess && onSuccess(checkedIds)
    } catch (error) {
      message.error(t('media:delete_failed') || 'Failed to delete items')
      setLoading(false)
    }
  }

  return (
    <Modal
      visible={visible}
      title={t('media:delete_warning') || t('v5:delete_items')}
      onOk={handleDelete}
      onCancel={onCancel}
      okButtonProps={{ disabled: checkedIds.length === 0, loading }}
      footer={[
        <Button key="back" onClick={onCancel}>
          {t('buttons:no') || t('v4:cancel')}
        </Button>,
        <Button
          key="submit"
          type="danger"
          disabled={checkedIds.length === 0}
          loading={loading}
          onClick={handleDelete}
        >
          {t('buttons:yes') || t('v4:delete')}
        </Button>
      ]}
    >
      <List
        dataSource={items}
        renderItem={item => (
          <List.Item>
            <Checkbox
              checked={checkedIds.includes(item.id)}
              onChange={e => handleCheck(item.id, e.target.checked)}
            >
              <span
                style={{
                  wordBreak: 'break-all',
                  maxWidth: 350,
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}
              >
                {item.title || item.name || `Item ${item.id}`}
              </span>
            </Checkbox>
          </List.Item>
        )}
      />
      <Divider />
      <Card>
        <p style={{ color: 'red' }}>{t('media:delete_message')}</p>

        <ul
          style={{
            listStyle: 'disc',
            marginLeft: '2rem'
          }}
        >
          <li>{t('v4:remove_sharebot_video')}</li>
          <li>{t('v4:remove_sharebot_video_audio')}</li>
        </ul>
      </Card>
      <Text type="danger" style={{ marginTop: 16, display: 'block' }}>
        {t('v4:are_you_sure_you_want_to_delete_the_selected_items')}
      </Text>
    </Modal>
  )
}

export default BulkDeleteModal
